import React, { useEffect, useState } from "react";
import { confirm } from "../utils/confirm";
import { messaggioErrore } from "../utils/erroriUtente";
import { collection, query, where, onSnapshot, addDoc, updateDoc, deleteDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../utils/Toast";
import { Plus, X, Zap } from "lucide-react";
import { TRIGGERS, CONDITION_FIELDS, CONDITION_OPS, ACTIONS } from "../pages/RegolePage";

function RegolaModal({ regola, onClose, orgId, projectId, utenti }) {
  const { addToast } = useToast();
  const [nome, setNome] = useState(regola?.nome || "");
  const [trigger, setTrigger] = useState(regola?.trigger || "");
  const [condizioni, setCondizioni] = useState(regola?.condizioni || []);
  const [azioni, setAzioni] = useState(regola?.azioni || [{ id: "", param: "" }]);
  const [saving, setSaving] = useState(false);

  const salva = async () => {
    if (!nome.trim()) { addToast("Nome obbligatorio", "error"); return; }
    if (!trigger) { addToast("Seleziona un trigger", "error"); return; }
    if (azioni.some(a => !a.id)) { addToast("Completa tutte le azioni", "error"); return; }
    setSaving(true);
    try {
      const dati = {
        nome: nome.trim(), trigger, condizioni, azioni,
        orgId, projectId,
        attiva: regola?.attiva !== false,
        scope: "progetto",
        updatedAt: serverTimestamp(),
      };
      if (regola?.id) await updateDoc(doc(db, "regole", regola.id), dati);
      else await addDoc(collection(db, "regole"), { ...dati, createdAt: serverTimestamp() });
      addToast("Regola salvata ✅", "success");
      onClose();
    } catch (err) { addToast(messaggioErrore(err), "error"); }
    setSaving(false);
  };

  const inp = { width:"100%",padding:"6px 9px",border:"1px solid #e5e7eb",borderRadius:6,fontSize:12,fontFamily:"'Inter',sans-serif",outline:"none",boxSizing:"border-box" };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:520,maxHeight:"88vh",overflowY:"auto"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
          <h3 style={{fontSize:15,fontWeight:700,display:"flex",alignItems:"center",gap:6}}>
            <Zap size={16} color="#7c3aed"/>{regola?"Modifica regola":"Nuova regola"}
          </h3>
          <button className="btn-icon" onClick={onClose}><X size={15}/></button>
        </div>

        <div className="form-group">
          <label className="form-label">Nome *</label>
          <input style={inp} value={nome} onChange={e=>setNome(e.target.value)} placeholder="Es. Notifica al completamento"/>
        </div>

        <div className="form-group">
          <label className="form-label">Quando (Trigger) *</label>
          <select style={inp} value={trigger} onChange={e=>setTrigger(e.target.value)}>
            <option value="">— Seleziona —</option>
            {TRIGGERS.map(t=><option key={t.id} value={t.id}>{t.label}</option>)}
          </select>
        </div>

        {/* Condizioni */}
        <div className="form-group">
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <label className="form-label" style={{marginBottom:0}}>Condizioni (opzionali)</label>
            <button onClick={()=>setCondizioni(c=>[...c,{field:"",op:"eq",value:""}])}
              style={{fontSize:11,color:"#7c3aed",background:"none",border:"1px solid #7c3aed",borderRadius:5,padding:"2px 7px",cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              + Aggiungi
            </button>
          </div>
          {condizioni.length===0&&<div style={{fontSize:11,color:"#9ca3af"}}>Nessuna — la regola si applica sempre</div>}
          {condizioni.map((cond,i)=>{
            const fd=CONDITION_FIELDS.find(f=>f.id===cond.field);
            return(
              <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:5,marginBottom:5,alignItems:"center"}}>
                <select style={{...inp,fontSize:11}} value={cond.field} onChange={e=>setCondizioni(c=>c.map((x,idx)=>idx===i?{...x,field:e.target.value}:x))}>
                  <option value="">— Campo —</option>
                  {CONDITION_FIELDS.map(f=><option key={f.id} value={f.id}>{f.label}</option>)}
                </select>
                <select style={{...inp,fontSize:11}} value={cond.op} onChange={e=>setCondizioni(c=>c.map((x,idx)=>idx===i?{...x,op:e.target.value}:x))}>
                  {CONDITION_OPS.map(o=><option key={o.id} value={o.id}>{o.label}</option>)}
                </select>
                {fd?.type==="select"?<select style={{...inp,fontSize:11}} value={cond.value} onChange={e=>setCondizioni(c=>c.map((x,idx)=>idx===i?{...x,value:e.target.value}:x))}>
                  <option value="">—</option>{fd.options.map(o=><option key={o} value={o}>{o}</option>)}
                </select>:fd?.type==="user"?<select style={{...inp,fontSize:11}} value={cond.value} onChange={e=>setCondizioni(c=>c.map((x,idx)=>idx===i?{...x,value:e.target.value}:x))}>
                  <option value="">—</option>{utenti.map(u=><option key={u.uid} value={u.uid}>{u.displayName}</option>)}
                </select>:<input style={{...inp,fontSize:11}} value={cond.value} onChange={e=>setCondizioni(c=>c.map((x,idx)=>idx===i?{...x,value:e.target.value}:x))} placeholder="Valore"/>}
                <button onClick={()=>setCondizioni(c=>c.filter((_,idx)=>idx!==i))} style={{background:"none",border:"none",cursor:"pointer",color:"#d1d5db"}} onMouseOver={e=>e.currentTarget.style.color="#dc2626"} onMouseOut={e=>e.currentTarget.style.color="#d1d5db"}><X size={12}/></button>
              </div>
            );
          })}
        </div>

        {/* Azioni */}
        <div className="form-group">
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <label className="form-label" style={{marginBottom:0}}>Allora (Azioni) *</label>
            <button onClick={()=>setAzioni(a=>[...a,{id:"",param:""}])}
              style={{fontSize:11,color:"#7c3aed",background:"none",border:"1px solid #7c3aed",borderRadius:5,padding:"2px 7px",cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              + Aggiungi
            </button>
          </div>
          {azioni.map((az,i)=>{
            const ad=ACTIONS.find(a=>a.id===az.id);
            return(
              <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr auto",gap:5,marginBottom:5,alignItems:"center"}}>
                <select style={{...inp,fontSize:11}} value={az.id} onChange={e=>setAzioni(a=>a.map((x,idx)=>idx===i?{...x,id:e.target.value,param:""}:x))}>
                  <option value="">— Azione —</option>
                  {ACTIONS.map(a=><option key={a.id} value={a.id}>{a.label}</option>)}
                </select>
                {ad?.param==="select"?<select style={{...inp,fontSize:11}} value={az.param} onChange={e=>setAzioni(a=>a.map((x,idx)=>idx===i?{...x,param:e.target.value}:x))}>
                  <option value="">—</option>{ad.options.map(o=><option key={o} value={o}>{o}</option>)}
                </select>:ad?.param==="user"?<select style={{...inp,fontSize:11}} value={az.param} onChange={e=>setAzioni(a=>a.map((x,idx)=>idx===i?{...x,param:e.target.value}:x))}>
                  <option value="">—</option>{utenti.map(u=><option key={u.uid} value={u.uid}>{u.displayName}</option>)}
                </select>:ad?.param==="text"?<input style={{...inp,fontSize:11}} value={az.param} onChange={e=>setAzioni(a=>a.map((x,idx)=>idx===i?{...x,param:e.target.value}:x))} placeholder="Valore"/>:<div/>}
                <button onClick={()=>azioni.length>1&&setAzioni(a=>a.filter((_,idx)=>idx!==i))} style={{background:"none",border:"none",cursor:azioni.length>1?"pointer":"not-allowed",color:"#d1d5db"}} onMouseOver={e=>{if(azioni.length>1)e.currentTarget.style.color="#dc2626"}} onMouseOut={e=>e.currentTarget.style.color="#d1d5db"}><X size={12}/></button>
              </div>
            );
          })}
        </div>

        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button className="btn btn-secondary" onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" onClick={salva} disabled={saving}>{saving?"Salvo...":"Salva regola"}</button>
        </div>
      </div>
    </div>
  );
}

export default function RegoleProgetto({ projectId, orgId, projectData }) {
  const { isOrgAdmin, isPlatformOwner, currentUser } = useAuth();
  const { addToast } = useToast();
  const commessaChiusa = projectData?.statoCommessa === "chiusa";
  const [regole, setRegole] = useState([]);
  const [utenti, setUtenti] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);

  useEffect(()=>{
    if(!projectId || !orgId) return; // commessa aperta solo per id: aspetto i suoi dati
    return onSnapshot(query(collection(db,"regole"),where("projectId","==",projectId),where("orgId","==",orgId)),
      snap=>setRegole(snap.docs.map(d=>({id:d.id,...d.data()}))));
  },[projectId, orgId]);

  useEffect(()=>{
    if(!orgId) return;
    return onSnapshot(query(collection(db,"users"),where("organizationId","==",orgId),where("enabled","==",true)),
      snap=>setUtenti(snap.docs.map(d=>d.data())));
  },[orgId]);

  const elimina = async id=>{ if (!await confirm("Eliminare?", { type:"danger" })) return; await deleteDoc(doc(db,"regole",id)); addToast("Eliminata","info"); };
  const toggle = async r=>{ await updateDoc(doc(db,"regole",r.id),{attiva:!r.attiva}); addToast(r.attiva?"Disattivata":"Attivata","success"); };

  return(
    <div style={{padding:20}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
        <div>
          <div style={{fontSize:15,fontWeight:700,display:"flex",alignItems:"center",gap:6}}>
            <Zap size={15} color="#7c3aed"/> Regole & Automazioni
          </div>
          <div style={{fontSize:12,color:"#9ca3af",marginTop:2}}>
            Si attivano automaticamente sulle attività di questa commessa
          </div>
        </div>
        <button onClick={()=>{ if(commessaChiusa){addToast("Commessa chiusa — non è più possibile creare nuove regole","error");return;} setEditing(null);setShowModal(true); }} className="btn btn-primary" style={{display:"flex",alignItems:"center",gap:5,fontSize:12}}>
          <Plus size={13}/> Nuova regola
        </button>
      </div>

      {regole.length===0?(
        <div style={{textAlign:"center",padding:48,color:"#9ca3af"}}>
          <Zap size={36} style={{opacity:0.2,marginBottom:10}}/>
          <div style={{fontSize:13,fontWeight:600}}>Nessuna regola ancora</div>
          <div style={{fontSize:12,marginTop:4}}>Crea una regola per automatizzare le attività di questa commessa</div>
        </div>
      ):(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {regole.map(r=>{
            const trig=TRIGGERS.find(t=>t.id===r.trigger);
            return(
              <div key={r.id} style={{background:"#fff",border:"1px solid #e5e7eb",borderRadius:10,padding:14,borderLeft:`4px solid ${r.attiva?"#7c3aed":"#d1d5db"}`}}>
                <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:r.attiva?"#111827":"#9ca3af",marginBottom:4,display:"flex",alignItems:"center",gap:6}}>
                      <Zap size={13} color={r.attiva?"#7c3aed":"#d1d5db"}/>
                      {r.nome}
                    </div>
                    <div style={{fontSize:11,color:"#6b7280"}}>
                      <span style={{fontWeight:600}}>Trigger:</span> {trig?.label||r.trigger}
                    </div>
                    {r.condizioni?.length>0&&<div style={{fontSize:11,color:"#6b7280"}}><span style={{fontWeight:600}}>Condizioni:</span> {r.condizioni.length}</div>}
                    <div style={{fontSize:11,color:"#6b7280"}}>
                      <span style={{fontWeight:600}}>Azioni:</span> {r.azioni?.map(a=>ACTIONS.find(x=>x.id===a.id)?.label||a.id).join(", ")}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                    <button onClick={()=>toggle(r)}
                      style={{fontSize:11,padding:"3px 8px",border:`1px solid ${r.attiva?"#7c3aed":"#d1d5db"}`,borderRadius:6,
                        background:r.attiva?"#ede9fe":"#f9fafb",color:r.attiva?"#7c3aed":"#9ca3af",cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
                      {r.attiva?"Attiva":"Inattiva"}
                    </button>
                    <button onClick={()=>{setEditing(r);setShowModal(true);}}
                      style={{fontSize:11,padding:"3px 8px",border:"1px solid #e5e7eb",borderRadius:6,background:"#fff",cursor:"pointer",fontFamily:"'Inter',sans-serif",color:"#6b7280"}}>
                      Modifica
                    </button>
                    <button onClick={()=>elimina(r.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#d1d5db",padding:2}} onMouseOver={e=>e.currentTarget.style.color="#dc2626"} onMouseOut={e=>e.currentTarget.style.color="#d1d5db"}>
                      <X size={13}/>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showModal&&<RegolaModal regola={editing} orgId={orgId} projectId={projectId} utenti={utenti} onClose={()=>{setShowModal(false);setEditing(null);}}/>}
    </div>
  );
}
